export const normalizePercentValue = (value: number): number => (
    // workaroud для IEEE приколов языка
    // 1.42 / 100 = 0.014499999999999999
    +value.toFixed(10)
    // эта хрень еще более производительна
    // но может вылезти за MAX_SAFE_INTEGER
    //Math.round(value * 1e10) / 1e10
);
